export enum ConfirmationDialogMessageMode {
    Text,
    Html
}